module.exports = __webpack_public_path__ + "img/sad.334a84a8.svg";